<template>
    <div class="content">
        <top-menu></top-menu>
        <div class="container-fluid"
          :class="[ SpecialClassName ]">
            <b-row class="content-container justify-content-center">
                <b-col cols="11" class="text-center">
                    <img class="padding-top rwd"
                      v-if="getIsMobile == false"
                      :src="getImageSrc('apply-steps.jpg')" />
                    <img class="padding-top rwd"
                      v-if="getIsMobile == true"
                      :src="getImageSrc('apply-steps_mobile.jpg')" />
                </b-col>
            </b-row>
        </div>
        <page-footer></page-footer>
    </div>
</template>
<script>
import TopMenu from '@/components/Menu/TopMenu'
import Footer from '@/components/Footer'
import { globalMixin, imageMixin, platformMixin } from '@/components/_Mixins'

const container_class_mapping = {
  applysteps: 'full-size'
}

export default {
    mounted() {
        // console.log(this.$route)
    },

    mixins: [ globalMixin, imageMixin, platformMixin ],

    components: {
        'top-menu': TopMenu,
        'page-footer': Footer,
    },

    computed: {
        SpecialClassName: function() {
          let routeName = this.RouteName

          console.log('Content.vue',
            ' check routeName : ',
            routeName)

          return this.getAttribute(container_class_mapping, routeName)
        },

        RouteName: function() {
          if (!this.$route) return ''

          let _routeName = this.$route.name
          if (_routeName !== undefined || _routeName != null) {
            return _routeName.toLowerCase()
          }

          return ''
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Content.vue